import { css as _css } from "@emotion/core";
import React from 'react';
import { CloseIconSmall } from '@domain-group/fe-co-icon';
import noop from '../../utils/noop';
import { Button } from '../button';
import styleFactory from './message.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Message = _ref => {
  var icon = _ref.icon,
    title = _ref.title,
    message = _ref.message,
    action = _ref.action,
    _ref$closeable = _ref.closeable,
    closeable = _ref$closeable === void 0 ? false : _ref$closeable,
    _ref$multiLine = _ref.multiLine,
    multiLine = _ref$multiLine === void 0 ? false : _ref$multiLine,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'info' : _ref$appearance,
    _ref$colours = _ref.colours,
    colours = _ref$colours === void 0 ? {} : _ref$colours,
    className = _ref.className,
    children = _ref.children,
    _ref$onAction = _ref.onAction,
    onAction = _ref$onAction === void 0 ? noop : _ref$onAction,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? noop : _ref$onClose;
  var Icon = icon;
  var styles = styleFactory({
    colours,
    appearance,
    multiLine
  });
  return ___EmotionJSX("section", {
    css: styles.messageBox,
    className: className
  }, Icon && ___EmotionJSX(Icon, {
    css: styles.icon
  }), ___EmotionJSX("div", {
    css: styles.messageContent
  }, title && ___EmotionJSX("div", {
    css: /*#__PURE__*/_css([styles.title, !multiLine && styles.singleLineTitle])
  }, title, multiLine && closeable && ___EmotionJSX(Button, {
    appearance: "ghost",
    size: "small",
    css: styles.close,
    onClick: onClose
  }, ___EmotionJSX(CloseIconSmall, {
    css: styles.closeIcon
  }))), message ? ___EmotionJSX("p", {
    css: styles.message
  }, message) : ___EmotionJSX("p", {
    css: styles.message
  }, children), action && ___EmotionJSX(Button, {
    appearance: "ghost",
    size: "small",
    css: styles.action,
    onClick: onAction
  }, action), closeable && !multiLine && ___EmotionJSX(Button, {
    appearance: "ghost",
    size: "small",
    css: styles.close,
    onClick: onClose
  }, ___EmotionJSX(CloseIconSmall, {
    css: styles.closeIcon
  }))));
};
export default Message;